
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M44 17H0v8h44v-8Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-cc__stripe",attrs:{"d":"M3.115 14.5h43.37m-43.37 7h43.37","stroke":"#234652"}}),_c('path',{staticClass:"i-cc__outline",attrs:{"stroke":"#234652","d":"M3.171 8.887h43.338v30.079H3.171z"}})])
          )
        }
      }
    